<script>
import Player from '@vimeo/player'
import Channel from '../channel/channel.vue'
import CommunityList from './community-list.vue'

export default {
  mixins: [],
  components: {
    Channel, CommunityList
  },
  props: {
    talkId: {type: String, required: true},
  },

  data() {
    return {
      talk: {},
      timer: null,
      showRegs: false,
      isFullscreen: false,
    }
  },

  computed: {
    streamingUrl() {
      // only give the streaming url if in streaming time frame

      const start = new Date(this.talk.start_datetime)
      const end = new Date(this.talk.end_datetime)
      const now = new Date()

      // subtract 30 minutes from the start and add 30 to the end
      start.setMinutes(start.getMinutes() - 30)
      end.setMinutes(end.getMinutes() + 30)

      if (now >= start && now <= end) {
        return this.talk.streaming_url
      }
      return null
    },
    videoUrl() {
      return this.talk.video_url ? this.talk.video_url : this.streamingUrl
    },
    userHasPermission() {
      if (this.talk.ticket_category) {
        if (this.talk.ticket_valid)
          return true
        return false
      }
      return true
    },
    userIsLoggedIn() {
      return this.$storage.getToken()
    },

  },

  watch: {
    talkId: {
      handler(newValue) {
        this.fetchTalk()
      },
    },
  },

  created() {
    this.fetchTalk()
  },

  mounted() {
    let me = this
    setTimeout(function() {me.initializeVimeoPlayer()}, 1000);
  },

  beforeDestroy() {
    this.stopTimer(); // Clear timer when the component is destroyed
  },

  methods: {
    baseName(url) {
      return url.split('/').pop()
    },

    fetchTalk: function (validateTicket=false) {
      let me = this
      let params = {}
      if (validateTicket) params['validate_ticket'] = 1
      this.$api.get(`/sessions/${this.talkId}/`, {params:params}).then(function(response) {
        if (!validateTicket) me.talk = response.data
      }).catch(function(error){console.error(error)})
    },

    initializeVimeoPlayer() {
      const iframe = document.getElementById('vimeo-player');
      const player = iframe ? new Player(iframe) : null ;

      if (!player) return

      player.on('play', () => {
        console.log('The video has started playing');
        this.fetchTalk(true)
        this.startTimer();
      });

      player.on('pause', () => {
        console.log('The video has been paused');
        this.stopTimer();
      });

      player.on('ended', () => {
        console.log('The video has ended');
        this.stopTimer();
      });
    },

    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.performTimedAction();
      }, 60000); // 60000 milliseconds = 1 minute
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    performTimedAction() {
      this.fetchTalk(true)
    },

    toggleFullscreen() {
      console.log('toggle')
      this.isFullscreen = !this.isFullscreen;
      if (this.isFullscreen) {
        this.enterFullscreen(this.$refs.videowrapper);
      } else {
        this.exitFullscreen();
      }
    },
    enterFullscreen(element) {
      console.log('enter')
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) { // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { // IE/Edge
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      console.log('leave')
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
      }
    }
  },
}
</script>

<template>
  <div>

    <talk-detail v-if="talk.id" :talk="talk" class="pb-3"/>

    <div v-if="userHasPermission" ref="videowrapper"
     class="pb-3 row" :class="{ fullscreen: isFullscreen }">
      <div class="col-8 d-flex align-items-center">
        <template v-if="videoUrl">
          <button class="btn btn-sm btn-outline-secondary c-button" @click="toggleFullscreen()">
            <i v-if="isFullscreen" class="fas fa-compress"></i>
            <i v-else class="fas fa-expand"></i>
          </button>
          <!--iframe :src="https://vimeo.com/event/4286780/embed/022378137e" width="560" height="315" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer"  allowfullscreen=""></iframe-->
          <iframe id="vimeo-player" style="height:100%"
          :src="videoUrl" width="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer"  allowfullscreen=""></iframe>
        </template>
        <template v-else>
          <img v-if="talk.streaming_image" class="img-thumbnail"
          :src="talk.streaming_image" :alt="talk.streaming_image">
        </template>
      </div>
      <div class="col-4 d-flex align-items-center">
        <div class="d-flex c-relative">
          <div v-if="talk.channel_id" class="c-chat-content">
            <channel :channelId="talk.channel_id" :nav-relative="true"></channel>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="talk.ticket_category" class="alert alert-danger my-3">
      <div v-if="!userIsLoggedIn">
        Sie müssen sich <a href="/accounts/login">anmelden</a> (login), um das Video und den Session-Chat zu laden!
      </div>
      <div v-else>
        <template v-if="talk.ticket_shop_url">
          Sie müssen sich für diesen Vortrag <a :href="talk.ticket_shop_url" target="_blank">registrieren</a>, um das Video und den Session-Chat zu sehen!
          Bitte diese Seite nach der Registrierung neu laden!
        </template>
        <template v-else>
          Sie müssen sich für diesen Vortrag registrieren, die Registrierung ist in Kürze verfügbar!
        </template>
      </div>
    </div>

    <div class="card my-3" v-if="talk && talk.documents && talk.documents.length">
      <div class="card-header">
        <h4>Downloads</h4>
      </div>
      <div class="card-body" v-for="d in talk.documents" :key="d.id">
        <a :href="d.file">{{ baseName(d.file) }}</a>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <h4 class="mb-0" v-if="talk.registered_mm_user_ids">
            Mitgliederregistrierungen
          <button class="btn btn-outline" @click.prevent="showRegs=!showRegs">
            <i v-if="showRegs" class="fa fa-chevron-down"></i>
            <i v-else class="fa fa-chevron-right"></i>
          </button>
        </h4>
      </div>
      <div v-if="showRegs" class="card-body">
        <community-list :talkContentCode="talk.content_code"/>
      </div>
    </div>

  </div>
</template>

<style scoped>

.c-button {
  position: absolute;
  top: 5px;
  left: 20px;
  z-index: auto;
  background: revert;
}

.c-relative {
  position: relative;
}

.c-chat-content {
  flex: 1;
  height: 60vh;
  overflow-y: auto;
  padding-bottom: 3rem;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  z-index: 9999;
  padding: 20px;
}

.fullscreen .c-chat-content {
  height: 98vh;
}

</style>